export default {
  title: 'Alvos de Busca',
  description: 'Defina os tipos de empresa e as localidades que o Scanner deve usar nas próximas buscas de prospecção.',
  labels: {
    new: 'Novo alvo de busca'
  }, 
  form: {
    title: 'Alvo de Busca'
  },
  fields: {
    segment: 'Segmento',
    country: 'País',
    state: 'Estado',
    city: 'Cidade',
    active: 'Ativo',
    radarStatus: 'Status do Radar',
    radarSlices: 'Estados esgotados',
    exhaustedAt: 'Esgotado em'
  },
  radarStatus: {
    available: 'Disponível',
    partial: 'Parcialmente esgotado',
    exhausted: 'Esgotado',
    disabled: 'Desativado'
  },
  errors: {
    ck_search_targets_segment_not_blank: 'Informe o segmento da busca.',
    ck_search_targets_country_code: 'Informe um país válido no formato ISO2.',
    ck_search_targets_state_code: 'O código do estado é inválido.',
    ck_search_targets_city_id: 'A cidade selecionada é inválida.',
    ck_search_targets_city_requires_state: 'Uma cidade só pode ser informada quando houver estado selecionado.',
    uq_search_targets_identity_active: 'Já existe um alvo de busca com o mesmo segmento e recorte geográfico.'
  }
};
